import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { createSelector, createStructuredSelector } from 'reselect';
import {
  signup,
  resetSuccessState,
  setReferral,
} from '../../redux/profile/actions';
import { successfullyRegistered, loading } from '../../redux/profile/selectors';
import { compose } from '../../utils';
import SignupForm from './SignupForm';

const signupSuccess = createSelector(successfullyRegistered, f => f);

const selector = createStructuredSelector({
  signupSuccess,
  loading,
});

const actions = { onSubmit: signup, resetSuccessState, setReferral };

const reduxConnect = connect(selector, actions);

const formConnect = reduxForm({
  form: 'signup',
});

export { SignupForm };

export default withRouter(compose(reduxConnect, formConnect)(SignupForm));
